import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const WorkloadId = iotsUtils.fromList(constants.user.status.workloadIds);

export const ManualId = iotsUtils.fromList(constants.user.status.manualIds);

export const Id = iotsUtils.fromList(constants.user.status.ids);
